module.exports = __webpack_public_path__ + "media/images/design/images/h2_topics-57b5d58caeac297957f1ac500533354b.png";